import { lazy } from 'react'

const STORAGE_KEY_PREFIX = 'chunkRetried:'

export const lazyWithRetry = componentImport =>
  lazy(async () => {
    try {
      return await componentImport()
    } catch (error) {
      if (error?.name === 'ChunkLoadError') {
        const storageKey = `${STORAGE_KEY_PREFIX}${error.request ?? error.message}`
        if (!sessionStorage.getItem(storageKey)) {
          sessionStorage.setItem(storageKey, '1')
          window.location.reload()
          return { default: () => null }
        }
        sessionStorage.removeItem(storageKey)
      }
      throw error
    }
  })
